import type React from "react";

import { styled } from "simplydo/react/styled";
import { Placeholder, type PlaceholderProps } from "simplydo/react/ui";

type PlaceholderItemProps = PlaceholderProps & { height: number };

export const PlaceholderItem = ({
  height,
  width,
  style = {},
  ...rest
}: PlaceholderItemProps) => (
  <Placeholder
    {...rest}
    style={{
      height,
      width,
      opacity: 0.7,
      borderRadius: 5,
      backgroundColor: "#fff",
      margin: 0,
      ...style,
    }}
  />
);

type PlaceholderStackProps = {
  gap?: number;
  children?: React.ReactNode;
  style?: React.CSSProperties;
};

const PlaceholderStackContainer = styled.div<{ $gap: number }>`
  display: flex;
  gap: ${({ $gap }) => $gap}px;
  flex-direction: column;
  > .ui.placeholder {
    margin: 0;
  }
`;

export const PlaceholderStack = ({
  gap,
  children,
  style = {},
}: PlaceholderStackProps) => (
  <PlaceholderStackContainer $gap={gap || 4} style={style}>
    {children}
  </PlaceholderStackContainer>
);
